/**
 * Minimal mobile panel coordination.
 *
 * At most ONE panel may be open at any time. Dispatch `switchToPanel(name)`
 * to activate a panel; every other panel listens and closes itself.
 * Pass `null` to close everything (e.g. "Start" tap).
 *
 * Panels handled:
 *   'categories' — CategoryDrawer
 *   'search'     — SearchModal (managed in Header)
 *   'favorites'  — FavoritesDrawer (managed in Header)
 *   'cart'       — CartDrawer (managed in Header)
 *   'menu'       — MobileMenuDrawer / hamburger (managed in Header)
 *   null         — close all
 */
export type MobilePanel = 'categories' | 'search' | 'cart' | 'menu' | 'favorites' | 'account' | null;

export const PANEL_EVENT = 'bk:mobile-panel' as const;

export function switchToPanel(panel: MobilePanel): void {
  window.dispatchEvent(new CustomEvent<MobilePanel>(PANEL_EVENT, { detail: panel }));
}

/**
 * Strona produktu montuje własny, sticky pasek CTA na dole ekranu na mobile
 * (cena + "Dodaj do koszyka"), wizualnie zasłaniający MobileBottomNav wyższym
 * z-index — ale MobileBottomNav przez cały czas zostaje ZAMONTOWANY pod spodem,
 * po prostu niewidoczny. Efekt: na stronie produktu na mobile istnieją
 * JEDNOCZEŚNIE dwa niezależnie kompozytowane elementy position:fixed
 * przyklejone do tej samej krawędzi ekranu — a to, w połączeniu z ich
 * mount/unmount przy wejściu/wyjściu ze strony produktu, jest dokładnie tym
 * rodzajem zamieszania w warstwach kompozycji, które potrafi mylić iOS
 * Safari przy position:fixed. Ten sygnał pozwala stronie produktu poprosić
 * MobileBottomNav, żeby się w ogóle NIE montował, dopóki własny pasek CTA
 * jest widoczny — zawsze istnieje co najwyżej jeden fixed pasek na dole.
 */
export const BOTTOM_NAV_OVERRIDE_EVENT = 'bk:bottom-nav-override' as const;

export function setBottomNavHidden(hidden: boolean): void {
  window.dispatchEvent(new CustomEvent<boolean>(BOTTOM_NAV_OVERRIDE_EVENT, { detail: hidden }));
}
